/* eslint no-shadow: 0 */
export enum PaymentType {
  CREDIT = 'credit_card',
  DEBIT = 'debit_card',
  BOLETO = 'boleto',
}
